import requests from "./httpService";

const ProjectService = {
     getAllProject: async () =>{
        return requests.get("/project/all");
     },
     getProjectById: async (id, body) =>{
        return requests.get(`/project/${id}`, body);
     },
     UpdateProjectById: async (id, body) =>{
        return requests.put(`/project/${id}`, body);
     },
     addProject: async (body) =>{
        return requests.post("/project/add", body);
     },
     deleteProjectById: async (id) =>{
        return requests.delete(`/project/${id}`);
     }
}

export default ProjectService;